import { useNavigate } from 'react-router-dom';
import HistoryView from '../components/screens/HistoryView';
import useUserQueues from '../hooks/useUserQueues';

function HistoryPage({ auth }) {
  const navigate = useNavigate();
  const {
    userQueues,
    queuesStatus,
    deletingQueueId,
    handleDeleteQueue,
  } = useUserQueues(auth.currentUser?.userId);

  return (
    <HistoryView
      userQueues={userQueues}
      queuesStatus={queuesStatus}
      deletingQueueId={deletingQueueId}
      onOpenQueue={(queue) =>
        navigate(`/queue/${queue?._id || ''}`, {
          state: {
            queue,
          },
        })
      }
      onDeleteQueue={handleDeleteQueue}
      onNewUpload={() => navigate('/queue')}
    />
  );
}

export default HistoryPage;
